<template>
  <Popover class="relative">
    <PopoverButton>
      <TEmojiDisplay
        :emoji-id="modelValue ?? undefined"
        :show-add="true"
        data-testid="t-emoji-editable"
        :class="[size === 'large' ? 'scale-[200%]' : '']"
      />
    </PopoverButton>

    <Transition
      :enter-from-class="animationClosedClasses"
      enter-active-class="duration-100"
      :enter-to-class="animationOpenedClasses"
      :leave-from-class="animationOpenedClasses"
      leave-active-class=""
      :leave-to-class="animationClosedClasses"
    >
      <PopoverPanel
        v-slot="{ close }"
        class="absolute z-[1000] rounded-sm bg-white shadow-md"
      >
        <div class="relative min-w-max overflow-x-hidden">
          <div
            v-if="modelValue"
            class="flex h-[40px] items-center justify-end px-[20px]"
          >
            <button
              class="rounded-xs px-2 py-1 text-xs text-neutral-500 duration-300 hover:bg-neutral-200 hover:text-neutral-400"
              @click="clearEmoji(close)"
            >
              <span>{{ $t('emoji.remove') }}</span>
            </button>
          </div>
          <TEmojiPicker
            @emoji-selected="
              (emoji: TEmoji) => {
                selectEmoji(emoji);
                close();
              }
            "
          />
        </div>
      </PopoverPanel>
    </Transition>
  </Popover>
</template>
<script lang="ts" setup>
import { $t } from '@teachino/shared-i18n';
import TEmojiDisplay from './TEmojiDisplay.vue';
import TEmojiPicker from './TEmojiPicker.vue';
import type { TEmoji } from './t-emoji';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';

defineProps<{
  modelValue: string | null;
  size?: 'default' | 'large';
}>();

const emit = defineEmits(['update:modelValue']);

const clearEmoji = (closeFunc: () => void): void => {
  emit('update:modelValue', null);
  closeFunc();
};

function selectEmoji(newEmoji: { colons: unknown }): void {
  emit('update:modelValue', newEmoji.colons);
}

const animationClosedClasses = 'opacity-0 pointer-events-none scale-90';
const animationOpenedClasses = 'opacity-100 pointer-events-auto scale-100';
</script>

<style scoped>
.emoji-mart {
  border-radius: 0px;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

@media screen and (max-width: 640px) {
  .emoji-mart {
    width: 280px !important;
  }
}
</style>
